module.exports = __webpack_public_path__ + "tim-bennetto-headshot-3d15697744d68cb0063c70eaaabd1ad9.webp";